const { atom } = require("recoil");

export const countriesState = atom({
  key: "countriesState"
});

export const optionsForCompanySettingState = atom({
  key: "optionsForCompanySettingState",
  default: []
});

export const optionsForReviewCycleState = atom({
  key: "optionsForReviewCycleState",
  default: {}
});

export const instructionsState = atom({
  key: "instructionsState",
  default: {}
});

export const currentInstructionState = atom({
  key: "currentInstructionState",
  default: {}
});
